/**
 * To be able to stub out window.location in tests, these are being wrapped in functions
 * If more window.location functions are used, this is where they should be added
 */

export const assign = (path: string) => window.location.assign(path);
export const href = () => window.location.href;
export const origin = () => window.location.origin;
export const pathname = () => window.location.pathname;
export const hostname = () => window.location.hostname;
export const reload = () => window.location.reload();
export const search = () => window.location.search;
export const open = window.open;
export const windowURL = window.URL;
